"use client";

import { useEffect } from "react";

export function ServiceWorkerRegistrar() {
  useEffect(() => {
    const isNative = !!(window as any).Capacitor?.isNativePlatform?.();
    if (isNative || !("serviceWorker" in navigator)) return;

    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Registration failures are non-fatal; the app works without the SW.
    });
  }, []);

  return null;
}
